import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { companyInfo } from "../data/mockData";

const Footer = () => {
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${companyInfo.whatsapp}`, "_blank");
  };

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="bg-royal-red p-2 rounded-lg">
                <span className="text-white font-bold text-xl">AD</span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">AD Motors</h3>
                <p className="text-xs text-metallic">ADモーターズ</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Japan's premier automotive import/export company, specializing in luxury vehicles and providing trusted global trading solutions.
            </p>
            <div className="flex space-x-3">
              <button
                onClick={handleWhatsAppClick}
                className="bg-green-600 hover:bg-green-700 p-2 rounded-full transition-colors"
              >
                <MessageCircle className="w-4 h-4 text-white" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Vehicle Inventory", path: "/inventory" },
                { name: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-royal-red transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>• Vehicle Export & Import</li>
              <li>• Auction Bidding Support</li>
              <li>• Logistics & Shipping</li>
              <li>• Custom Clearance</li>
              <li>• Local Sales & Dealer Services</li>
              <li>• Quality Inspection</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-sm">
                <Phone className="w-4 h-4 text-royal-red" />
                <div>
                  <p className="text-gray-300">{companyInfo.landline}</p>
                  <p className="text-gray-300">{companyInfo.mobile}</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 text-sm">
                <Mail className="w-4 h-4 text-royal-red" />
                <span className="text-gray-300">{companyInfo.email}</span>
              </div>
              
              <div className="flex items-center space-x-2 text-sm">
                <MapPin className="w-4 h-4 text-royal-red" />
                <span className="text-gray-300">{companyInfo.address}</span>
              </div>
              
              <div className="flex items-center space-x-2 text-sm">
                <Clock className="w-4 h-4 text-royal-red" />
                <span className="text-gray-300">{companyInfo.businessHours}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 AD Motors (ADモーターズ). All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0 text-xs text-gray-400">
              <span>Corporate Number: {companyInfo.corporateNumber}</span>
              <span>Postal Code: {companyInfo.postalCode}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;